import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DataTable, { IColumn } from "../../../components/table/data/DataTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import IProfile from "../../../models/profile";
import profileService from "../../../services/profile/ProfileService";
import Toolbar from "../../../components/toolbar/Toolbar";
import DownloadTable from "../../../utils/download/downloadDataTable";
import { IFilter } from "../../../components/table/data/filter/DataFilter";

const useProfileColumns = () => {
    const { t } = useTranslation();
    const columns: IColumn<IProfile>[] = [
        { field: "name", headerName: t("table.profile.name") },
    ];
    return columns;
};

const ProfilePage = () => {
    const [profiles, setProfiles] = useState<IProfile[]>([]);

    const columns = useProfileColumns();
    const { t } = useTranslation([""]);
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);
    const navigate = useNavigate();

    const [filteredRows, setFilteredRows] = useState(profiles);
    const [selectedFilters, setSelectedFilters] = useState<
        Map<string, IFilter>
    >(new Map());

    const visibleFilters: string[] = [];
    selectedFilters.forEach((filter, field) => {
        if (!filter.isActive || !filter.request) return;
        const column = columns.find((column) => column.field === field);
        visibleFilters.push(`${column?.headerName}: ${t(`periodical:filter.${filter.type}`)} ${filter.request}`);
    });

    const downloadTable = new DownloadTable("profile", filteredRows, columns, t("table.profile.title"), visibleFilters);

    useEffect(() => {
        profileService.GetProfiles().then(setProfiles);
    }, []);
    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Toolbar
                onFilterClick={() => setIsFilterActive((old) => !old)}
                onCreate={() => navigate("add")}
                isFilterActive={isFilterActive}
                downloadButtons={[
                    { label: "Excel", onClick: () => downloadTable.GetExcel(t("header.exportedBy"), t("header.exportDate")) },
                    { label: "CSV", onClick: () => downloadTable.GetCSV() },
                    { label: "PDF", onClick: () => downloadTable.GetPDF(t("header.exportedBy"), t("header.exportDate")) }
                ]}
            />

            <DataTable
                dense
                disableFiltrer={!isFilterActive}
                rows={profiles}
                columns={columns}
                onRowClick={(row) => {
                    navigate("edit", { state: { ...row } });
                }}
                getRowNavTo={(row) => "edit"}
                onSetFilter={(filteredRows, selectedFilters) => {
                    setFilteredRows(filteredRows)
                    setSelectedFilters(selectedFilters)
                }}
            />
        </Box>

    );
};

export default ProfilePage;
